export default {
  title: 'Nova categoria',
  form: {
    menus: {
      label: 'Menus',
    },
    printer: {
      label: 'Impressora',
    },
    type: {
      label: 'Tipo',
    },
    name: {
      label: 'Nome',
      placeholder: 'Introduza o nome da categoria',
    },
    description: {
      label: 'Descrição',
      placeholder: 'Introduza a descrição',
    },
    has_combo_tax: {
      label: 'Tem imposto de combo',
    },
    modifier_groups: {
      label: 'Grupos de modificadores',
    },
    image: {
      label: 'Imagem',
    },
    identifiers: {
      label: 'Identificadores',
    },
    has_separate_schedule: {
      label: 'Varia do horário do menu',
    },
  },
  buttons: {
    save: 'Guardar',
    close: 'Fechar',
  },
  feedback: {
    missing_info: 'Informação em falta',
  },
  toasts: {
    category_got_created: 'Categoria criada',
    category_got_updated: 'Categoria atualizada',
  },
};
